import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import Section from '@app/Section';

@Component({
  selector: 'app-auto-focus-input',
  templateUrl: './auto-focus-input.component.html',
  styleUrls: ['./auto-focus-input.component.less']
})
export class AutoFocusInputComponent {
  @Input() isSectionActive: boolean;
  @Input() section: Section & {isEditable: boolean};
  @ViewChild('input') public inputRef: ElementRef;

  ngDoCheck() {
    if(this.section.isEditable) {
      setTimeout(() => this.inputRef.nativeElement.focus(), 0);
    }
  }

  onSectionInputClick(event) {
    event.stopPropagation();
  }

  onSectionInputKeyUp(event, section) {
    if (event.keyCode === 13 && event.target.value) {
      section.isEditable = false;
      section.title = event.target.value;
    }
  }

  stopSectionEdit(event, section) {
    event.target.value = section.title;
    section.isEditable = false;
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/edit/sections-panel/auto-focus-input/auto-focus-input.component.ts